import { render } from "./SSA.vue?vue&type=template&id=b6973ede&ts=true"
import script from "./SSA.vue?vue&type=script&lang=ts"
export * from "./SSA.vue?vue&type=script&lang=ts"

import "./SSA.vue?vue&type=style&index=0&id=b6973ede&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__